import React from 'react';
import { LucideIcon } from 'lucide-react';

interface MetricPillProps {
  icon: LucideIcon;
  count: number;
  className?: string;
}

export function MetricPill({ icon: Icon, count, className = '' }: MetricPillProps) {
  if (count <= 0) return null;

  return (
    // The count is the only data on a project card, so it reads as data:
    // 13px semibold with tabular-nums, which keeps the numbers aligned down a
    // scrolling list. The icon stays quieter than the number it labels.
    // Colours are secondary, not tertiary: --text-tertiary on
    // --bg-surface-alt is 4.36:1 in light and 4.15:1 in dark, both below the
    // 4.5:1 floor. (DESIGN.md certifies tertiary at 4.77:1, but that is
    // measured on --bg-primary, not on the alt surface.)
    <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-md text-[13px] leading-[18px] font-semibold tabular-nums bg-[var(--bg-surface-alt)] text-[var(--text-primary)] ${className}`}>
      <Icon size={14} className="text-[var(--text-secondary)]" aria-hidden="true" />
      {count}
    </span>
  );
}
